

















































import Vue from 'vue';
import Component from 'vue-class-component';
import MeterRouter from '@/context/meter/router/MeterRouter';
import { MeterFilter } from '@/context/meter/model/MeterFilter';
import PageContainer from '@/general/component/PageContainer.vue';
import { meterApi } from '@/context/meter/api/MeterApi';
import CustomerAutocomplete from '@/general/component/form/autocomplete/CustomerAutocomplete.vue';
import DataLoggerAutocomplete
  from '@/general/component/form/autocomplete/DataLoggerAutcomplete.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';

@Component({
  components: {
    PageContainer,
    CustomerAutocomplete,
    FacilityAutocomplete,
    DataLoggerAutocomplete,
    TextInput
  }
})
export default class MeterListContainer extends Vue {
  router: MeterRouter = new MeterRouter();
  filter: MeterFilter = new MeterFilter();
  entityHeaders: Array<Record<string, unknown>> = [
    {
      text: "Numer licznika",
      value: "meterNumber",
      align: "left"
    },
    {
      text: "Model licznika",
      value: "model",
      align: "left"
    },
    // {
    //   text: 'Producent licznika',
    //   value: 'manufacturer',
    //   align: 'left'
    // },
    {
      text: "Lokalizacja",
      value: "location",
      align: "left"
    },
    {
      text: "Lokalizacja cd.",
      value: "locationLong",
      align: "left"
    },
    {
      text: "Opis",
      value: "description",
      align: "left"
    },
    {
      text: "Mikroserwer",
      value: "dataLoggerIdentifier",
      align: "left"
    },
    {
      text: "Obiekt",
      value: "facilityStoreNumber",
      align: "left"
    },
    {
      text: "Klient",
      value: "clientName",
      align: "left"
    }
  ];
  api = meterApi;
}
